export { default } from './DisappearingInformationQuizStep';
